import { StaticImage } from '@/common/constants/displateRoutes';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

/**
 * @returns '/accessories'
 */
export const RouteToAccessoriesPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: `/accessories`, target: 'external' });
};

export const AccessoriesPageConfig: PageConfig = {
  readableName: 'Accessory Page',
  analyticsGaName: 'accessories',
  analyticsAthenaName: 'accessories',
  pagePathnames: ['/accessories'],
  displayPromoBar: true,
  defaultMeta: {
    title: `How to mount Displate? Accessories! Stand, 3D Magnet, Sticker Magnet | Displate`,
    description: `Explore the world of Displate Accessories – your go-to source for enhancing your magnetic art experience.
        Elevate your Displate metal poster collection with our specially curated Displate Mounting Kit: Displate Stand, 3D Magnet, and Sticker Magnet.
        Easily transform your space in seconds with our user-friendly mounting system and follow our precise mounting instruction.`,
    coverImage: StaticImage('/images/accessories/og_image.jpg'),
  },
};

export const AccessoriesPageHeaderHeights = {
  desktop: 162,
  mobile: 162,
};
